var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import * as React from 'react';
import InputField from '@kiwicom/orbit-components/lib/InputField';
import ButtonLink from '@kiwicom/orbit-components/lib/ButtonLink';
import Visibility from '@kiwicom/orbit-components/lib/icons/Visibility';
import VisibilityOff from '@kiwicom/orbit-components/lib/icons/VisibilityOff';
var PasswordInput = /** @class */ (function (_super) {
    __extends(PasswordInput, _super);
    function PasswordInput(props) {
        var _this = _super.call(this, props) || this;
        _this.state = {
            visible: false,
        };
        return _this;
    }
    PasswordInput.prototype.render = function () {
        var _this = this;
        return (_jsx(InputField, __assign({ type: this.state.visible ? 'text' : 'password', suffix: _jsx(ButtonLink, { icon: this.state.visible ? _jsx(VisibilityOff, {}) : _jsx(Visibility, {}), onClick: function () {
                    return _this.setState(function (prevState) { return ({ visible: !prevState.visible }); });
                } }) }, this.props)));
    };
    return PasswordInput;
}(React.Component));
export default PasswordInput;
